/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Attachment_UnreadableInputs */



/**
* | output |
* | --- |
* | "Wundo couldn't read that file. Send it as a PDF, or paste the text." |
*
* @param {Chat_Attachment_UnreadableInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const chat_attachment_unreadable = /** @type {((inputs?: Chat_Attachment_UnreadableInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Attachment_UnreadableInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Wundo kon dit bestand niet lezen. Stuur het als pdf, of plak de tekst.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Wundo n'a pas pu lire ce fichier. Envoyez-le en PDF, ou collez le texte.")
	return /** @type {LocalizedString} */ ("Wundo couldn't read that file. Send it as a PDF, or paste the text.")
});